<div id="donation-tables" [ngClass]="{'with-facebook-fundraiser-donations': eventService?.selectedEvent?.gql?.Participant[0]?.fundraiser?.activeFacebookFundraiserProfiles[0]?.facebookFundraiserId}">
    <!-- START: dashboard alpha -->
    <nav class="cat__core__top-sidebar cat__core__top-sidebar--bg">
        <span class="cat__core__title d-block mt-2 mb-2">
            <strong *ngIf="isDonationPage">My Donations</strong>
            <strong *ngIf="!isDonationPage">Matching Gifts/Sponsorships</strong>
        </span>
        <div class="d-flex align-items-center d-lg-none facebook-fundraiser-sticky-nav-button">
            <a class="ui-accept-donation btn btn-primary btn-sm edit-team d-inline-block facebook-fundraiser-btn facebook-fundraiser-btn-mobile"
               *ngIf="eventService?.selectedEvent?.gql?.Participant[0]?.fundraiser?.activeFacebookFundraiserProfiles[0]?.facebookFundraiserId"
               (click)="hybridToolsService.openExternalLink(facebookFundraiserUrl)" target="_blank">
                View on facebook
            </a>

            <button class="ui-accept-donation btn btn-primary btn-sm edit-team d-inline-block"
               *ngIf="!eventService?.selectedEvent?.isPastEvent && eventService?.selectedEvent?.gql?.Participant[0]?.fundraiser.canAcceptDonations"
               (click)="donationService.acceptIndividualDonation('Donations')">Accept Donation
            </button>
        </div>
    </nav>
    <div class="d-none d-lg-block sticky-nav-button facebook-fundraiser-sticky-nav-button"
         *ngIf="eventService?.selectedEvent?.gql?.Participant[0]?.fundraiser?.activeFacebookFundraiserProfiles[0]?.facebookFundraiserId" >
        <a (click)="hybridToolsService.openExternalLink(facebookFundraiserUrl)" target="_blank" class="btn btn-sm btn-primary facebook-fundraiser-btn">
            View on facebook
        </a>
    </div>
    <div class="d-none d-lg-block sticky-nav-button">
        <button class="btn btn-primary btn-sm edit-team d-inline-block"
           *ngIf="!eventService?.selectedEvent?.isPastEvent && eventService?.selectedEvent?.gql?.Participant[0]?.fundraiser.canAcceptDonations"
           (click)="donationService.acceptIndividualDonation('Donations')">Accept Donation
        </button>
    </div>

    <!-- Modal -->
    <ng-template #selectEvent let-c="close" let-d="dismiss">
        <div class="modal-header">
            <h5 class="modal-title">Select an Event</h5>
            <button type="button" class="close" aria-label="Close" (click)="d()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <h5 class="text-black">
                <strong>Active Events</strong>
            </h5>
            <ul>
                <li *ngFor="let event of eventService?.events">
                    <a href="javascript:void(0)" (click)="onEventSelect(event)">{{ event?.label }}</a>
                </li>
            </ul>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn" (click)="c()">Cancel</button>
        </div>
    </ng-template>
    <!-- End Modal -->


    <div class="row ui-personal-cards-wrapper cards__wrapper mt-4 mt-md-0">
        <div class="col-sm-12 col-xl-4 card__content"
			 [class.col-xl-6]="eventService.selectedEvent.cssClass !== 'program-tnt'
			 && eventService.selectedEvent.cssClass !== 'program-ltn'
			 && eventService.selectedEvent.cssClass !== 'program-regatta'
			 && eventService.selectedEvent.cssClass !== 'program-s2'">
            <counter-widget title="Total Raised" class="totalraised" icon="fa fa-thumbs-up">
                <div class="widget-icon d-flex">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 640 640">
                        <title></title>
                        <g id="icomoon-ignore">
                        </g>
                        <path fill="#03AB32" d="M112 640h-96c-8.836 0-16-7.163-16-16v-224c0-8.837 7.164-16 16-16h96c8.836 0 16 7.163 16 16v224c0 8.837-7.164 16-16 16zM32 608h64v-192h-64v192z"></path>
                        <path fill="#03AB32" d="M272 640h-96c-8.836 0-16-7.163-16-16v-320c0-8.836 7.164-16 16-16h96c8.836 0 16 7.164 16 16v320c0 8.837-7.164 16-16 16zM192 608h64v-288h-64v288z"></path>
                        <path fill="#03AB32" d="M432 640h-96c-8.837 0-16-7.163-16-16v-288c0-8.837 7.163-16 16-16h96c8.837 0 16 7.163 16 16v288c0 8.837-7.163 16-16 16zM352 608h64v-256h-64v256z"></path>
                        <path fill="#03AB32" d="M592 640h-96c-8.837 0-16-7.163-16-16v-416c0-8.836 7.163-16 16-16h96c8.837 0 16 7.164 16 16v416c0 8.837-7.163 16-16 16zM512 608h64v-384h-64v384z"></path>
                        <path fill="#03AB32" d="M571.313 36.687c-4.285-4.286-10.626-5.783-16.373-3.865l-96 32c-8.383 2.794-12.914 11.855-10.119 20.238 2.794 8.383 11.858 12.914 20.238 10.119l31.702-10.567-137.448 137.447c-6.826 6.826-19.588 7.734-27.313 1.941l-76.8-57.6c-19.979-14.984-50.77-14.334-70.099 1.48l-151.233 123.737c-6.839 5.596-7.847 15.676-2.251 22.515 3.163 3.866 7.759 5.869 12.393 5.869 3.563 0 7.149-1.185 10.123-3.617l151.233-123.736c7.884-6.451 22.486-6.758 30.635-0.647l76.8 57.6c20.583 15.437 50.951 13.276 69.14-4.913l137.448-137.448-10.567 31.702c-2.795 8.383 1.736 17.444 10.119 20.238 1.679 0.56 3.385 0.826 5.062 0.826 6.699 0 12.942-4.24 15.177-10.945l32-96c1.916-5.751 0.419-12.089-3.867-16.374z"></path>
                    </svg>
                </div>
               <p class="widget-content">
                   <span class="ui-personal-total-raised-amount text-black widget-font-number">
                       ${{eventService?.selectedEvent?.donations?.individual?.totalRaised | number: '1.2-2'}}
                   </span>

                   <small>
                       <a class="ui-total-raised-link text-primary"
                          href="javascript:void(0)"
                          (click)="openTotalRaisedModal()">View Totals by Category
                       </a>
                   </small>
               </p>
            </counter-widget>
        </div>

        <div class="col-sm-12 col-xl-4 card__content"
			 [class.col-xl-6]="eventService.selectedEvent.cssClass !== 'program-tnt'
			 && eventService.selectedEvent.cssClass !== 'program-ltn'
			 && eventService.selectedEvent.cssClass !== 'program-regatta'
			 && eventService.selectedEvent.cssClass !== 'program-s2'"
        [class.col-sm-12]="eventService.selectedEvent.cssClass !== 'program-tnt'
		&& eventService.selectedEvent.cssClass !== 'program-ltn'
		&& eventService.selectedEvent.cssClass !== 'program-regatta'
		&& eventService.selectedEvent.cssClass !== 'program-s2'">
            <counter-widget title="Goal: ${{eventService?.selectedEvent?.donations?.individual?.goal | number}}" class="goal" icon="fa fa-flag-checkered">
                <div class="widget-icon d-flex">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 640 640">
                        <title></title>
                        <g id="icomoon-ignore">
                        </g>
                        <path fill="#2A79AA" d="M501.463 535.149c6.005-5.146 11.846-10.538 17.497-16.189 57.419-57.418 89.040-133.759 89.040-214.96 0-47.456-10.635-92.918-31.61-135.124-3.933-7.913-13.532-11.141-21.449-7.208-7.913 3.933-11.14 13.536-7.207 21.449 18.756 37.742 28.266 78.413 28.266 120.883 0 149.981-122.019 272-272 272s-272-122.019-272-272 122.019-272 272-272c42.471 0 83.14 9.51 120.879 28.265 7.916 3.933 17.517 0.704 21.449-7.208 3.933-7.913 0.706-17.516-7.207-21.449-42.204-20.973-87.665-31.608-135.121-31.608-81.202 0-157.542 31.622-214.96 89.040s-89.040 133.758-89.040 214.96c0 81.201 31.622 157.542 89.040 214.96 5.651 5.651 11.492 11.043 17.497 16.188l-40.847 81.696c-3.952 7.903-0.748 17.515 7.156 21.466 2.297 1.148 4.738 1.693 7.143 1.693 5.869 0 11.52-3.242 14.323-8.849l38.075-76.151c50.154 34.447 109.454 52.997 171.613 52.997s121.459-18.55 171.614-52.996l38.075 76.151c2.803 5.607 8.453 8.849 14.323 8.849 2.404 0 4.846-0.545 7.143-1.693 7.903-3.951 11.107-13.562 7.155-21.466l-40.847-81.696z"></path>
                        <path fill="#2A79AA" d="M304 480c-97.047 0-176-78.953-176-176s78.953-176 176-176c24.468 0 48.157 4.931 70.41 14.655 8.098 3.538 11.793 12.971 8.255 21.068-3.539 8.098-12.973 11.795-21.067 8.254-18.189-7.947-37.567-11.977-57.598-11.977-79.402 0-144 64.598-144 144s64.598 144 144 144c79.401 0 144-64.599 144-144 0-25.322-6.659-50.218-19.259-71.996-4.425-7.649-1.812-17.437 5.838-21.861 7.645-4.426 17.436-1.812 21.861 5.837 15.414 26.642 23.56 57.079 23.56 88.020 0 97.047-78.953 176-176 176z"></path>
                        <path fill="#2A79AA" d="M528 128h-48v-48c0-8.836-7.163-16-16-16s-16 7.164-16 16v56.577c-21.918 18.711-100.491 87.424-156.494 157.428-5.521 6.9-4.402 16.969 2.499 22.489 2.95 2.36 6.479 3.507 9.985 3.507 4.693 0 9.344-2.055 12.504-6.005 54.558-68.199 134.004-137.449 153.374-153.996h58.132c8.837 0 16-7.164 16-16s-7.163-16-16-16z"></path>
                        <path fill="#2A79AA" d="M592 96h-64c-8.837 0-16-7.164-16-16v-64c0-8.836 7.163-16 16-16s16 7.164 16 16v48h48c8.837 0 16 7.164 16 16s-7.163 16-16 16z"></path>
                        <path fill="#2A79AA" d="M304 384c-44.112 0-80-35.888-80-80 0-36.524 24.678-68.384 60.011-77.479 8.56-2.202 17.281 2.95 19.483 11.507s-2.949 17.28-11.507 19.483c-21.188 5.454-35.987 24.571-35.987 46.489 0 26.468 21.533 48 48 48s48-21.532 48-48c0-8.836 7.163-16 16-16s16 7.164 16 16c0 44.112-35.888 80-80 80z"></path>
                    </svg>
                </div>
                <p class="widget-content">
                    <span class="ui-personal-raised-percent text-black widget-font-number" *ngIf="eventService?.selectedEvent?.donations?.individual?.goal === 0">
                        0%
                    </span>
                    <span class="ui-personal-raised-percent text-black widget-font-number" *ngIf="eventService?.selectedEvent?.donations?.individual?.goal > 0">
                        {{eventService?.selectedEvent?.donations?.individual?.percentComplete}}%
                    </span>
                    <small>
                        <a class="ui-edit-personal-goal text-primary"
                          href="javascript:void(0)"
                          *ngIf="!eventService?.selectedEvent?.isPastEvent"
                          (click)="openChangeGoalModal()">Edit Goal
                        </a>
                    </small>
                </p>
            </counter-widget>
        </div>

        <div class="col-sm-12 col-xl-4 card__content" *ngIf="eventService.selectedEvent.cssClass === 'program-tnt'
			 || eventService.selectedEvent.cssClass === 'program-ltn'
			 || eventService.selectedEvent.cssClass === 'program-regatta'
			 || eventService.selectedEvent.cssClass === 'program-s2'">
            <counter-widget title="Leaderboard" class="leaderboard dark" icon="fa fa-trophy">
                <div class="widget-icon d-flex">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 640 640">
                        <title></title>
                        <g id="icomoon-ignore">
                        </g>
                        <path fill="#FFC425" d="M592 256h-176v-144c0-8.836-7.163-16-16-16h-192c-8.836 0-16 7.164-16 16v80h-176c-8.836 0-16 7.164-16 16v320c0 8.837 7.164 16 16 16h576c8.837 0 16-7.163 16-16v-256c0-8.837-7.163-16-16-16zM224 128h160v384h-160v-384zM32 224h160v288h-160v-288zM576 512h-160v-224h160v224z"></path>
                        <path fill="#FFC425" d="M304 320c-8.836 0-16-7.163-16-16v-128c0-8.836 7.164-16 16-16s16 7.164 16 16v128c0 8.837-7.164 16-16 16z"></path>
                        <path fill="#FFC425" d="M144 416h-64c-8.836 0-16-7.163-16-16v-64c0-8.837 7.164-16 16-16h48v-32h-48c-8.836 0-16-7.163-16-16s7.164-16 16-16h64c8.836 0 16 7.163 16 16v64c0 8.837-7.164 16-16 16h-48v32h48c8.836 0 16 7.163 16 16s-7.164 16-16 16z"></path>
                        <path fill="#FFC425" d="M528 320h-64c-8.837 0-16 7.163-16 16s7.163 16 16 16h48v32h-48c-8.837 0-16 7.163-16 16s7.163 16 16 16h48v32h-48c-8.837 0-16 7.163-16 16s7.163 16 16 16h64c8.837 0 16-7.163 16-16v-128c0-8.837-7.163-16-16-16z"></path>
                    </svg>
                </div>
                <div class="widget-content">
                    <p>
                        <span class="ui-leaderboard-rank-value text-black widget-font-number" *ngIf="eventService?.selectedEvent?.gql?.Participant[0]?.fundraiser?.fundraiserPosition !== 0">
                            {{eventService?.selectedEvent?.gql?.Participant[0]?.fundraiser?.fundraiserPosition}}
                        </span>
                        <span class="ui-leaderboard-rank-value text-black widget-font-number" *ngIf="eventService?.selectedEvent?.gql?.Participant[0]?.fundraiser?.fundraiserPosition === 0">-</span>
                        <small class="leaderboard-rank text-black widget-font-number small" *ngIf="eventService?.selectedEvent?.gql?.Participant[0]?.fundraiser?.fundraiserCount !== 0">
							/ {{eventService?.selectedEvent?.gql?.Participant[0]?.fundraiser?.fundraiserCount}}
						</small>
                        <small class="leaderboard-rank text-black widget-font-number small" *ngIf="eventService?.selectedEvent?.gql?.Participant[0]?.fundraiser?.fundraiserCount === 0">
							/ -
						</small>
                    </p>
                    <small><a class="ui-edit-personal-goal text-primary"
                              (click)="hybridToolsService.openExternalLink(eventService?.selectedEvent?.gql?.Participant[0]?.participantEventUrls[0]?.participantEventUrl)"
                              target="_blank"
                              *ngIf="eventService?.selectedEvent?.gql?.Participant[0]?.participantEventUrls[0]?.participantEventUrl">
                    View Leaderboards</a></small>
                </div>
            </counter-widget>
        </div>

    </div>

    <div class="row">
        <div class="col-lg-12">
            <div id="bottom-col">
                <section class="card" order-id="card-13">
                    <div class="card-body">
                        <lls-datagrid [options]="donationGridOptions" #donationsTable *ngIf="isDonationPage"></lls-datagrid>
                        <lls-datagrid [options]="promiseGridOptions" #promisesTable *ngIf="!isDonationPage"></lls-datagrid>
                    </div>
                </section>
            </div>
        </div>
    </div>
    <!-- END: dashboard alpha -->
</div>
